import { CHAT_MESSAGE_DIRECTIONS } from 'cpool-constants';

import type { ChatMessage } from '~/features/whatsapp/types/message';

// The read cursor is a watermark over inbound messages only — marking an outbound tail would move
// the watermark into a gap where there is nothing to count, while still clearing the badge when
// unread inbound sits below an outbound tail.
export const findLastInboundMessage = (messages: Array<ChatMessage>): ChatMessage | undefined => {
    for (let index = messages.length - 1; index >= 0; index -= 1) {
        const message = messages[index];
        if (message.direction === CHAT_MESSAGE_DIRECTIONS.INBOUND) return message;
    }
    return undefined;
};
